import { Box, Button, Text, VStack, Input } from '@chakra-ui/react';
import React, { useState } from 'react';

import { error as commonError } from '@finley-technologies/common';

export const TestExternalFilename = ({
  externalFilename,
}: {
  externalFilename: string;
}) => {
  const [regEx, setRegEx] = useState<string>(externalFilename);
  const [input, setInput] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [matches, setMatches] = useState<string>('');

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    try {
      // this must use  same check as that of ingest-organizer
      const match = !!input.match(`^${regEx}.*$`);
      setMatches(match ? 'Yes' : 'No');
    } catch (error) {
      setErrorMessage(commonError.getErrorMessage(error));
    }
  };

  return (
    <Box mt={4} border="1px solid" padding={2}>
      <Text>Test ExternalFilename</Text>
      <VStack mt={4} as="form" onSubmit={handleSubmit} align="start">
        <Text>RegEx:</Text>
        <Input
          value={regEx}
          onChange={(e) => setRegEx(e.target.value)}
          placeholder="Enter regular expression"
        />

        <Text mt={2}>Input:</Text>
        <Input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Enter input"
        />

        <Button type="submit">Test</Button>

        <Text>Matches: {matches}</Text>
        {errorMessage && <Text color="red">{errorMessage}</Text>}
      </VStack>
    </Box>
  );
};
